import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import styles from './CustomLink.module.css';

type CustomLinkType = {
    children: ReactNode,
    to: string,
    isActive?: Boolean,
    title?: string
    className?: any
}

const CustomLink = (props: CustomLinkType) => {
    return (
        <Link title={props.title || ''} className={`${props.className} ${styles.link} ${props.isActive ? styles.isActive : ''}`} to={props.to}>{props.children}</Link>
    )
}

export default CustomLink;